module.exports = __webpack_public_path__ + "static/media/logo_2.5d8874e7.png";